import {CompetitionDomainModel} from "../../../domain/common/competition/models/competition-domain-model";
import {SeasonStageDomainModel} from "../../../domain/season-stage/models/season-stage.domain-model";
import {SeasonStageViewModel} from "../../../domain/season-stage/models/season-stage.view-model";

export class StandingsWidgetStageViewModel extends SeasonStageViewModel {
  domainModel: SeasonStageDomainModel;

  constructor(stage: SeasonStageDomainModel, competition: CompetitionDomainModel ) {
    super(stage);

    this.competition = competition;
  }

  get id(): String {
    return `${this.competition.id} - ${super.num}`
  }

  get name(): String {
    return `${this.competition.name} - ${super.name}`
  }

  get competitionId(): String {
    return this.competition.id;
  }

  get currentCompetitionStageNum(): String {
    return this.competition.currentStageNum;
  }
}